import { memo, useCallback } from 'react'
import styles from './VNCartButtons.module.scss'
import VNPlusButton from './VNPlusButton'
import { useDispatch, useSelector } from 'react-redux'
import useOfflineModal from '../../hooks/useOfflineModal'
import { setRoute } from '../../VNRoutes/ActionCreators'
//import useGetIsMobileScreen from "../../hooks/useGetIsMobileScreen"
import { getDiscountsAvailable, getSelectedPromotions } from '../../selectors/promotion'
import { getTabsModeEnabled } from '../../selectors/menus'
import CartItem from '../../components/CartItem'
import { addPromotionsToOrder } from '../../actions/promotion'

const VNDiscounts = () => {
  const dispatch = useDispatch()
  const [checkIfOfflineWithCallback, offlineModal] = useOfflineModal()
  //const isMobileViewPort = useGetIsMobileScreen()
  const discounts = useSelector(getSelectedPromotions)
  const discountsAvailable = useSelector(getDiscountsAvailable)
  const tabsModeEnabled = useSelector(getTabsModeEnabled)

  const discountsSubtext = 'Discounts are not supported while the device is offline. Please find a stable network connection.'

  const discountsHandler = useCallback(() => {
    checkIfOfflineWithCallback(() => dispatch(setRoute('/concession-order/select-discount')), discountsSubtext, false)
  }, [dispatch, checkIfOfflineWithCallback, discountsSubtext])

  const removeHandler = useCallback(
    (id) => {
      const selectedPromotions = discounts.filter((selectedDiscount) => selectedDiscount.uuid !== id)
      dispatch(addPromotionsToOrder({ selectedPromotions }))
    },
    [dispatch, discounts],
  )

  if (!discountsAvailable || tabsModeEnabled) {
    return null
  }

  return (
    <>
      {discounts.length > 0 && (
        <div className={styles.itemsContainer}>
          {discounts.map((discount, index, discounts) => (
            <CartItem
              key={`${discount.uuid}-${index}`}
              {...discount}
              index={discount.uuid}
              onRemove={removeHandler}
              className={styles.cartItem}
              isDiscount={true}
            />
          ))}
        </div>
      )}
      <div className={styles.container}>
        {offlineModal}
        <span className={styles.title}>Discounts</span>
        <VNPlusButton className={styles.button} onClick={discountsHandler} />
      </div>
    </>
  )
}

export default memo(VNDiscounts)
